<template>
  <div class="admin-settings">
      <p>inställningar</p>
  </div>
</template>



<script>
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:"AdminSettings",
    components: {LoadingSpinner},
    data() {
        return {
        }
    },
    methods: { 
    },
    computed: {
        ...mapGetters(['user','admin'])
    },
    created() {
    },

}
</script>

<style>

</style>